import React, { Fragment } from "react";

import Modal from "../modal/modal";

const Error = (props) => (
  <Fragment>
    {/* {props.error && <Backdrop onClick={props.onHandle} />} */}
    {props.error && (
      <Modal
        title={
          props.type
            ? ' Warning'
            : "An Error Occurred"
        }
        onCloseModal={props.onHandle}
        type={props.type ? "warning" : "error"}
        isError={true}
        isOpen={props.error}
      >
        <div className="py-10">
          <p
            className={`text-xl ${
              props.type ? "text-yellow-500" : "text-red-600"
            }`}
          >
            {props.error}
          </p>
        </div>
      </Modal>
    )}
  </Fragment>
);

export default Error;
